import React from 'react';
import QRCode from 'react-qr-code';
import { useSelector, useDispatch } from 'react-redux';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { getBasePath } from 'js/utils/general';
import { generateShareCard } from 'js/utils/qrCard';

// import actions
import { notificationPrompt } from 'js/store/notification/notification.actions';

// import components
import ActivityCard from 'js/components/activity-card/ActivityCard';
import ButtonWithIcon from 'js/components/button/Button.with-icon';
import { trackEvent } from '../../../utils/tracking';

// import selectors
import { getTranslationById } from 'js/store/app/App.selectors';
import { getLocale } from 'js/store/app/App.selectors';

const CardShare = ({ cardID }) => {
  const dispatch = useDispatch();
  const card = useSelector((state) => state.cards.byId[cardID] || false);
  const url = `${window.location.origin}${getBasePath() === '/' ? '' : getBasePath()}/card/${cardID}`;

  const siteText = {
    title: useSelector((state) => getTranslationById(state, 'overlay_popup_share_this_card', 'Share this card')),
    saveQrCode: useSelector((state) => getTranslationById(state, 'overlay_popup_save_qr_code', 'Save QR Code')),
    copyLink: useSelector((state) => getTranslationById(state, 'overlay_popup_copy_link', 'Copy Link')),
  };

  const locale = useSelector((state) => getLocale(state));

  return (
    <div className="collection-modal__share">
      <OverlayScrollbarsComponent defer className="custom-scrollbar" style={{ height: '100vh' }}>
        <h1 style={{ marginBottom: 35 }}>{siteText.title}</h1>
        <div style={{ maxWidth: 185, margin: '0 auto' }}>
          <ActivityCard allowFlip={false} data={card} />
        </div>
        <div className="card-modal">
          <div
            style={{
              height: 'auto',
              margin: '0 auto',
              maxWidth: 190,
              width: '100%',
              padding: 15,
              background: 'white',
              borderRadius: 15,
            }}
          >
            <QRCode
              size={256}
              style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
              value={url}
              viewBox={`0 0 256 256`}
              id="qr-code"
            />
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            gap: 10,
            marginTop: 30,
            justifyContent: 'center',
            paddingBottom: 100,
          }}
        >
          <ButtonWithIcon
            title={siteText.saveQrCode}
            iconName={'download'}
            style={{
              fontSize: 14,
            }}
            action={() => {
              downloadPng(card, locale, () => {
                dispatch(notificationPrompt({ type: 'QR_CODE_SAVED', additionalData: false }));
              });
            }}
          />
          <ButtonWithIcon
            title={siteText.copyLink}
            iconName={'link'}
            style={{
              fontSize: 14,
            }}
            action={() => {
              trackEvent('game_copy_link_click', { content_id: card.id, content_name: card.title });
              navigator.clipboard
                .writeText(url)
                .then(() => {
                  dispatch(notificationPrompt({ type: 'LINK_COPIED', additionalData: false }));
                  console.log('Link copied to clipboard!');
                })
                .catch((err) => {
                  console.error('Failed to copy the link: ', err);
                });
            }}
          />
        </div>
      </OverlayScrollbarsComponent>
    </div>
  );
};

export default CardShare;

const downloadPng = (card, locale, cb) => {
  const name = locale === 'es' ? card.front.localisation.title || '' : card.title || '';
  const image = card.front.largeImage || '';

  const svg = document.getElementById('qr-code');
  if (!svg) return;

  const serializer = new XMLSerializer();
  const svgString = serializer.serializeToString(svg);

  const svgBlob = new Blob([svgString], {
    type: 'image/svg+xml;charset=utf-8',
  });

  const url = URL.createObjectURL(svgBlob);

  generateShareCard({ name, image, qr: url, type: locale === 'es' ? 'Tarjeta' : 'Card', locale }, cb);
};
